import {
  Companion_instance1jc5thgshmt53 as Companion_instance,
  get_serializabletahhnzjs6wap as get_serializable,
  get_doStoreInSnapshot2ouhd6iwtr8a6 as get_doStoreInSnapshot,
  Component1lglqnbx5ofkj as Component,
  Companion_instance1l2xi6jq9r026 as Companion_instance_0,
  EdgeConnector18c5afzui3cj0 as EdgeConnector,
  SurfaceConnector2qgrveebgrhin as SurfaceConnector,
  Transform2e9p9l2euepqa as Transform,
  PointConnector2aof4iylw00ug as PointConnector,
  StaticComponent1ujjt0txbrs9g as StaticComponent,
  ConnectionRootComponent3fd9sp0aqznxo as ConnectionRootComponent,
  SnapRootComponent157nyaf19ls92 as SnapRootComponent,
  ConnectorsComponent32a4eg1gtppvf as ConnectorsComponent,
  LocalTransformComponent1ihphzx3x7pnv as LocalTransformComponent,
  Companion_getInstance1cmxj7l93cwya as Companion_getInstance,
  almostEquals23kj4jzvxfqs8 as almostEquals,
  get_geometricMean39gejc7rixqh6 as get_geometricMean,
  Companion_getInstanceoonrb8185bmg as Companion_getInstance_0,
  Companion_instance1f7k6iwukor7l as Companion_instance_1,
  DragSurface3d7ocyb1ribou as DragSurface,
  Companion_getInstanceblwi6p98rjjg as Companion_getInstance_1,
  Degrees1pmrlnndueajq as Degrees,
  Vector1cgy08ha6e7ya as Vector,
  DragSurfacesComponent2obth6ol1y4en as DragSurfacesComponent,
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  Radians3bflt61di9nby as Radians,
} from './core-core-api.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  defineProp3hxgpk2knu2px as defineProp,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  contains1tccixv8iwdcq as contains,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  contentEqualsaf55p28mnw74 as contentEquals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toString1pkumu07cwy4m as toString,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$,
  copyToArray2j022khrow2yi as copyToArray,
  listOf1jh22dvmctj1r as listOf,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  Paire9pteg33gng7 as Pair,
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$_0,
  roundToInt1ue8x8yshtznx as roundToInt,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(RoomComponent, 'RoomComponent', RoomComponent, VOID, [Component]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(RoomConnectorConstants, 'RoomConnectorConstants', RoomConnectorConstants);
initMetadataForClass(RoomConnectorConstantsData, 'RoomConnectorConstantsData');
initMetadataForCompanion(Companion_1);
initMetadataForClass(RoomCornerDefinition, 'RoomCornerDefinition');
initMetadataForCompanion(Companion_2);
initMetadataForClass(RoomDefinitionsUtils, 'RoomDefinitionsUtils', RoomDefinitionsUtils);
initMetadataForClass(RoomEdgeDefinition, 'RoomEdgeDefinition');
initMetadataForCompanion(Companion_3);
initMetadataForClass(RoomPartType, 'RoomPartType', RoomPartType);
initMetadataForCompanion(Companion_4);
initMetadataForClass(RoomPartComponent, 'RoomPartComponent', VOID, VOID, [Component]);
initMetadataForClass(RoomSurfaceDefinition, 'RoomSurfaceDefinition');
initMetadataForCompanion(Companion_5);
initMetadataForClass(RoomSurfaceType, 'RoomSurfaceType', RoomSurfaceType);
initMetadataForClass(WallSurfaceData, 'WallSurfaceData');
initMetadataForObject(WallCornerAngleOffersGenerator, 'WallCornerAngleOffersGenerator');
//endregion
function Companion() {
  Companion_instance_2 = this;
  this.id = Companion_instance.w1o_1;
}
protoOf(Companion).n1s = function () {
  return this.id;
};
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 == null)
    new Companion();
  return Companion_instance_2;
}
function RoomComponent() {
  Companion_getInstance_2();
}
protoOf(RoomComponent).p1s = function () {
  return Companion_getInstance_2().id;
};
protoOf(RoomComponent).eq = function (other) {
  return true;
};
function get_isRoom(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_2().id);
}
function Companion_0() {
  Companion_instance_3 = this;
  this.ROOM_SURFACE_KEY = 'room-surface';
  this.CONTINUOUS_OFFER = 'continuous';
  this.EDGE_WALL_CEILING_OFFER = 'wall-ceiling-edge';
  this.EDGE_WALL_CEILING_KEY = this.EDGE_WALL_CEILING_OFFER;
  this.EDGE_WALL_FLOOR_OFFER = 'wall-floor-edge';
  this.EDGE_WALL_FLOOR_KEY = this.EDGE_WALL_FLOOR_OFFER;
  this.EDGE_WALL_WALL_OFFER = 'wall-wall-edge';
  this.EDGE_WALL_WALL_KEY = this.EDGE_WALL_WALL_OFFER;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.EDGE_WALL_CEILING_OFFERS = [this.EDGE_WALL_CEILING_OFFER, this.CONTINUOUS_OFFER];
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.EDGE_WALL_FLOOR_OFFERS = [this.EDGE_WALL_FLOOR_OFFER, this.CONTINUOUS_OFFER];
  var tmp_1 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_1.EDGE_WALL_WALL_OFFERS = [this.EDGE_WALL_WALL_OFFER, this.CONTINUOUS_OFFER];
  this.CORNER_WALL_FLOOR_OFFER = 'wall-corner';
  this.CORNER_WALL_FLOOR_KEY = this.CORNER_WALL_FLOOR_OFFER;
  this.CORNER_WALL_CEILING_OFFER = 'ceiling-corner';
  this.CORNER_WALL_CEILING_KEY = this.CORNER_WALL_CEILING_OFFER;
  this.WALL_OFFER = 'wall';
  this.FLOOR_OFFER = 'floor';
  this.CEILING_OFFER = 'ceiling';
  this.TOP_SURFACE_OFFER = 'top-surface';
  var tmp_2 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_2.FLOOR_OFFERS = [this.FLOOR_OFFER, this.CONTINUOUS_OFFER, this.TOP_SURFACE_OFFER];
  var tmp_3 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_3.WALL_OFFERS = [this.WALL_OFFER, this.CONTINUOUS_OFFER];
  var tmp_4 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_4.CEILING_OFFERS = [this.CEILING_OFFER, this.CONTINUOUS_OFFER];
}
protoOf(Companion_0).n3k = function () {
  return this.ROOM_SURFACE_KEY;
};
protoOf(Companion_0).o3k = function () {
  return this.CONTINUOUS_OFFER;
};
protoOf(Companion_0).p3k = function () {
  return this.EDGE_WALL_CEILING_OFFER;
};
protoOf(Companion_0).q3k = function () {
  return this.EDGE_WALL_CEILING_KEY;
};
protoOf(Companion_0).r3k = function () {
  return this.EDGE_WALL_FLOOR_OFFER;
};
protoOf(Companion_0).s3k = function () {
  return this.EDGE_WALL_FLOOR_KEY;
};
protoOf(Companion_0).t3k = function () {
  return this.EDGE_WALL_WALL_OFFER;
};
protoOf(Companion_0).u3k = function () {
  return this.EDGE_WALL_WALL_KEY;
};
protoOf(Companion_0).v3k = function () {
  return this.EDGE_WALL_CEILING_OFFERS;
};
protoOf(Companion_0).w3k = function () {
  return this.EDGE_WALL_FLOOR_OFFERS;
};
protoOf(Companion_0).x3k = function () {
  return this.EDGE_WALL_WALL_OFFERS;
};
protoOf(Companion_0).y3k = function () {
  return this.CORNER_WALL_FLOOR_OFFER;
};
protoOf(Companion_0).z3k = function () {
  return this.CORNER_WALL_FLOOR_KEY;
};
protoOf(Companion_0).a3l = function () {
  return this.CORNER_WALL_CEILING_OFFER;
};
protoOf(Companion_0).b3l = function () {
  return this.CORNER_WALL_CEILING_KEY;
};
protoOf(Companion_0).c3l = function () {
  return this.WALL_OFFER;
};
protoOf(Companion_0).d3l = function () {
  return this.FLOOR_OFFER;
};
protoOf(Companion_0).e3l = function () {
  return this.CEILING_OFFER;
};
protoOf(Companion_0).f3l = function () {
  return this.TOP_SURFACE_OFFER;
};
protoOf(Companion_0).g3l = function () {
  return this.FLOOR_OFFERS;
};
protoOf(Companion_0).h3l = function () {
  return this.WALL_OFFERS;
};
protoOf(Companion_0).i3l = function () {
  return this.CEILING_OFFERS;
};
protoOf(Companion_0).hasFloorPlacement = function (connection) {
  var hostConnector = connection.hostConnector;
  return hostConnector.isOffering(this.FLOOR_OFFER) || hostConnector.isOffering(this.EDGE_WALL_FLOOR_OFFER) || hostConnector.isOffering(this.CORNER_WALL_FLOOR_OFFER);
};
protoOf(Companion_0).hasWallPlacement = function (connection) {
  var hostConnector = connection.hostConnector;
  return hostConnector.isOffering(this.WALL_OFFER) || hostConnector.isOffering(this.EDGE_WALL_CEILING_OFFER) || hostConnector.isOffering(this.EDGE_WALL_WALL_OFFER);
};
protoOf(Companion_0).hasCornerPlacement = function (connection) {
  return connection.hostConnector.isOffering(this.CORNER_WALL_FLOOR_OFFER);
};
protoOf(Companion_0).j3l = function (adjacentSurfaceTypes) {
  return contains(adjacentSurfaceTypes, Companion_instance_8.n3l_1) ? new RoomConnectorConstantsData(this.EDGE_WALL_CEILING_KEY, this.EDGE_WALL_CEILING_OFFERS) : contains(adjacentSurfaceTypes, Companion_instance_8.m3l_1) ? new RoomConnectorConstantsData(this.EDGE_WALL_FLOOR_KEY, this.EDGE_WALL_FLOOR_OFFERS) : new RoomConnectorConstantsData(this.EDGE_WALL_WALL_KEY, this.EDGE_WALL_WALL_OFFERS);
};
protoOf(Companion_0).o3l = function (adjacentSurfaceTypes) {
  var tmp;
  if (contains(adjacentSurfaceTypes, Companion_instance_8.n3l_1)) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [this.CORNER_WALL_CEILING_OFFER];
    tmp = new RoomConnectorConstantsData(this.CORNER_WALL_CEILING_KEY, tmp$ret$2);
  } else {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [this.CORNER_WALL_FLOOR_OFFER];
    tmp = new RoomConnectorConstantsData(this.CORNER_WALL_FLOOR_KEY, tmp$ret$5);
  }
  return tmp;
};
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 == null)
    new Companion_0();
  return Companion_instance_3;
}
function get_ROOM_SURFACE_KEY() {
  return Companion_getInstance_3().ROOM_SURFACE_KEY;
}
function get_CONTINUOUS_OFFER() {
  return Companion_getInstance_3().CONTINUOUS_OFFER;
}
function get_EDGE_WALL_CEILING_OFFER() {
  return Companion_getInstance_3().EDGE_WALL_CEILING_OFFER;
}
function get_EDGE_WALL_CEILING_KEY() {
  return Companion_getInstance_3().EDGE_WALL_CEILING_KEY;
}
function get_EDGE_WALL_FLOOR_OFFER() {
  return Companion_getInstance_3().EDGE_WALL_FLOOR_OFFER;
}
function get_EDGE_WALL_FLOOR_KEY() {
  return Companion_getInstance_3().EDGE_WALL_FLOOR_KEY;
}
function get_EDGE_WALL_WALL_OFFER() {
  return Companion_getInstance_3().EDGE_WALL_WALL_OFFER;
}
function get_EDGE_WALL_WALL_KEY() {
  return Companion_getInstance_3().EDGE_WALL_WALL_KEY;
}
function get_EDGE_WALL_CEILING_OFFERS() {
  return Companion_getInstance_3().EDGE_WALL_CEILING_OFFERS;
}
function get_EDGE_WALL_FLOOR_OFFERS() {
  return Companion_getInstance_3().EDGE_WALL_FLOOR_OFFERS;
}
function get_EDGE_WALL_WALL_OFFERS() {
  return Companion_getInstance_3().EDGE_WALL_WALL_OFFERS;
}
function get_CORNER_WALL_FLOOR_OFFER() {
  return Companion_getInstance_3().CORNER_WALL_FLOOR_OFFER;
}
function get_CORNER_WALL_FLOOR_KEY() {
  return Companion_getInstance_3().CORNER_WALL_FLOOR_KEY;
}
function get_CORNER_WALL_CEILING_OFFER() {
  return Companion_getInstance_3().CORNER_WALL_CEILING_OFFER;
}
function get_CORNER_WALL_CEILING_KEY() {
  return Companion_getInstance_3().CORNER_WALL_CEILING_KEY;
}
function get_WALL_OFFER() {
  return Companion_getInstance_3().WALL_OFFER;
}
function get_FLOOR_OFFER() {
  return Companion_getInstance_3().FLOOR_OFFER;
}
function get_CEILING_OFFER() {
  return Companion_getInstance_3().CEILING_OFFER;
}
function get_TOP_SURFACE_OFFER() {
  return Companion_getInstance_3().TOP_SURFACE_OFFER;
}
function get_FLOOR_OFFERS() {
  return Companion_getInstance_3().FLOOR_OFFERS;
}
function get_WALL_OFFERS() {
  return Companion_getInstance_3().WALL_OFFERS;
}
function get_CEILING_OFFERS() {
  return Companion_getInstance_3().CEILING_OFFERS;
}
function hasFloorPlacement(connection) {
  return Companion_getInstance_3().hasFloorPlacement(connection);
}
function hasWallPlacement(connection) {
  return Companion_getInstance_3().hasWallPlacement(connection);
}
function hasCornerPlacement(connection) {
  return Companion_getInstance_3().hasCornerPlacement(connection);
}
function constantsForEdge(adjacentSurfaceTypes) {
  return Companion_getInstance_3().j3l(adjacentSurfaceTypes);
}
function constantsForCorner(adjacentSurfaceTypes) {
  return Companion_getInstance_3().o3l(adjacentSurfaceTypes);
}
function RoomConnectorConstants() {
  Companion_getInstance_3();
}
function RoomConnectorConstantsData(connectorId, offers) {
  this.connectorId = connectorId;
  this.offers = offers;
}
protoOf(RoomConnectorConstantsData).p3l = function () {
  return this.connectorId;
};
protoOf(RoomConnectorConstantsData).q3l = function () {
  return this.offers;
};
protoOf(RoomConnectorConstantsData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RoomConnectorConstantsData))
    THROW_CCE();
  if (!(this.connectorId === other.connectorId))
    return false;
  if (!contentEquals(this.offers, other.offers))
    return false;
  return true;
};
protoOf(RoomConnectorConstantsData).hashCode = function () {
  var result = getStringHashCode(this.connectorId);
  result = imul(31, result) + contentHashCode(this.offers) | 0;
  return result;
};
protoOf(RoomConnectorConstantsData).tf = function () {
  return this.connectorId;
};
protoOf(RoomConnectorConstantsData).uf = function () {
  return this.offers;
};
protoOf(RoomConnectorConstantsData).r3l = function (connectorId, offers) {
  return new RoomConnectorConstantsData(connectorId, offers);
};
protoOf(RoomConnectorConstantsData).copy = function (connectorId, offers, $super) {
  connectorId = connectorId === VOID ? this.connectorId : connectorId;
  offers = offers === VOID ? this.offers : offers;
  return this.r3l(connectorId, offers);
};
protoOf(RoomConnectorConstantsData).toString = function () {
  return 'RoomConnectorConstantsData(connectorId=' + this.connectorId + ', offers=' + toString(this.offers) + ')';
};
function addFloorCornerAngleToOffers($this, connectorId, surfaces, point, offers) {
  var isFloorCorner = connectorId === Companion_getInstance_3().CORNER_WALL_FLOOR_KEY;
  var tmp;
  if (isFloorCorner) {
    var offerForCornerAngle = WallCornerAngleOffersGenerator_getInstance().t3l(surfaces, point);
    var tmp_0;
    if (offerForCornerAngle == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.ipex.room.Companion.addFloorCornerAngleToOffers.<anonymous>' call
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [offerForCornerAngle];
      tmp_0 = offers.concat(tmp$ret$3);
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp = tmp1_elvis_lhs == null ? offers : tmp1_elvis_lhs;
  } else {
    tmp = offers;
  }
  var offersWithAngle = tmp;
  return offersWithAngle;
}
function Companion_1() {
}
protoOf(Companion_1).u3l = function (point1, point2, adjacentSurfaceTypes) {
  var _destruct__k2r9zo = Companion_getInstance_3().j3l(adjacentSurfaceTypes);
  var connectorId = _destruct__k2r9zo.tf();
  var offers = _destruct__k2r9zo.uf();
  return new EdgeConnector(connectorId, Companion_instance_0.m2b_1, point1, point2, VOID, VOID, VOID, VOID, VOID, offers);
};
protoOf(Companion_1).v3l = function (id, points, offers) {
  var tmp0_type = Companion_instance_0.m2b_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp1_demandsArray = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp2_tagArray = [];
  var connector = new SurfaceConnector(id, tmp0_type, points, VOID, VOID, true, tmp2_tagArray, offers, tmp1_demandsArray);
  return connector;
};
protoOf(Companion_1).w3l = function (point, surfaces, adjacentSurfaceTypes) {
  var _destruct__k2r9zo = Companion_getInstance_3().o3l(adjacentSurfaceTypes);
  var connectorId = _destruct__k2r9zo.tf();
  var offers = _destruct__k2r9zo.uf();
  var offersWithAngle = addFloorCornerAngleToOffers(this, connectorId, surfaces, point, offers);
  return new PointConnector(connectorId, Companion_instance_0.m2b_1, new Transform(point), VOID, VOID, VOID, VOID, offersWithAngle);
};
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function RoomCornerDefinition(connector, entityTransform, adjacentSurfaceTypes) {
  this.connector = connector;
  this.entityTransform = entityTransform;
  this.adjacentSurfaceTypes = adjacentSurfaceTypes;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.mandatoryComponents = [new StaticComponent(), new ConnectionRootComponent(), new SnapRootComponent(), new RoomPartComponent(Companion_instance_6.y3l_1)];
}
protoOf(RoomCornerDefinition).t1m = function () {
  return this.connector;
};
protoOf(RoomCornerDefinition).g3m = function () {
  return this.entityTransform;
};
protoOf(RoomCornerDefinition).h3m = function () {
  return this.adjacentSurfaceTypes;
};
protoOf(RoomCornerDefinition).m1w = function () {
  return this.mandatoryComponents;
};
protoOf(RoomCornerDefinition).asComponents = function () {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.mandatoryComponents;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [this.connector];
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [new ConnectorsComponent(tmp$ret$2)];
  var this_1 = this_0.concat(tmp$ret$6);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [new LocalTransformComponent(this.entityTransform)];
  return this_1.concat(tmp$ret$11);
};
protoOf(RoomCornerDefinition).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RoomCornerDefinition))
    THROW_CCE();
  if (!this.connector.equals(other.connector))
    return false;
  if (!this.entityTransform.equals(other.entityTransform))
    return false;
  if (!contentEquals(this.adjacentSurfaceTypes, other.adjacentSurfaceTypes))
    return false;
  return true;
};
protoOf(RoomCornerDefinition).hashCode = function () {
  var result = this.connector.hashCode();
  result = imul(31, result) + this.entityTransform.hashCode() | 0;
  result = imul(31, result) + contentHashCode(this.adjacentSurfaceTypes) | 0;
  return result;
};
protoOf(RoomCornerDefinition).tf = function () {
  return this.connector;
};
protoOf(RoomCornerDefinition).uf = function () {
  return this.entityTransform;
};
protoOf(RoomCornerDefinition).m1m = function () {
  return this.adjacentSurfaceTypes;
};
protoOf(RoomCornerDefinition).i3m = function (connector, entityTransform, adjacentSurfaceTypes) {
  return new RoomCornerDefinition(connector, entityTransform, adjacentSurfaceTypes);
};
protoOf(RoomCornerDefinition).copy = function (connector, entityTransform, adjacentSurfaceTypes, $super) {
  connector = connector === VOID ? this.connector : connector;
  entityTransform = entityTransform === VOID ? this.entityTransform : entityTransform;
  adjacentSurfaceTypes = adjacentSurfaceTypes === VOID ? this.adjacentSurfaceTypes : adjacentSurfaceTypes;
  return this.i3m(connector, entityTransform, adjacentSurfaceTypes);
};
protoOf(RoomCornerDefinition).toString = function () {
  return 'RoomCornerDefinition(connector=' + this.connector.toString() + ', entityTransform=' + this.entityTransform.toString() + ', adjacentSurfaceTypes=' + toString(this.adjacentSurfaceTypes) + ')';
};
function surfaceTypeFromNormal($this, normal) {
  var surfaceType = normal.equals(Companion_getInstance().UP) ? Companion_instance_8.m3l_1 : normal.equals(Companion_getInstance().DOWN) ? Companion_instance_8.n3l_1 : isVerticalSurface($this, normal) ? Companion_instance_8.l3l_1 : Companion_instance_8.k3l_1;
  return surfaceType;
}
function isVerticalSurface($this, normal) {
  return almostEquals(normal.dot(Companion_getInstance().UP), 0.0);
}
function Companion_2() {
}
protoOf(Companion_2).j3m = function (worldVertices) {
  var center = get_geometricMean(worldVertices);
  var normal = Companion_getInstance_0().a2i(worldVertices).normalize();
  var surfaceType = surfaceTypeFromNormal(this, normal);
  var entityTransform = Companion_instance_1.b2i(normal, center);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(worldVertices.length);
  var inductionVariable = 0;
  var last = worldVertices.length;
  while (inductionVariable < last) {
    var item = worldVertices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.ipex.room.Companion.surfaceDefinitions.<anonymous>' call
    var tmp$ret$0 = entityTransform.inverseTransformPosition(item);
    destination.h(tmp$ret$0);
  }
  var localPoints = copyToArray(destination);
  var tmp;
  if (surfaceType === Companion_instance_8.m3l_1) {
    tmp = Companion_getInstance_3().FLOOR_OFFERS;
  } else if (surfaceType === Companion_instance_8.l3l_1) {
    tmp = Companion_getInstance_3().WALL_OFFERS;
  } else if (surfaceType === Companion_instance_8.n3l_1) {
    tmp = Companion_getInstance_3().CEILING_OFFERS;
  } else {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [Companion_getInstance_3().CONTINUOUS_OFFER];
  }
  var offers = tmp;
  var surfaceConnector = Companion_instance_4.v3l(Companion_getInstance_3().ROOM_SURFACE_KEY, localPoints, offers);
  var dragSurfaceShape = Companion_getInstance_0().i3c(localPoints);
  var dragSurface = new DragSurface(dragSurfaceShape, null, true);
  return new RoomSurfaceDefinition(surfaceConnector, entityTransform, dragSurface, surfaceType);
};
protoOf(Companion_2).k3m = function (polygons) {
  var meanNormal = Companion_getInstance().ZERO;
  var inductionVariable = 0;
  var last = polygons.length;
  while (inductionVariable < last) {
    var points = polygons[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    meanNormal = meanNormal.plus(Companion_getInstance_0().a2i(points));
  }
  return meanNormal.normalize();
};
protoOf(Companion_2).l3m = function (worldPoint1, worldPoint2, surface1WorldVertices, surface2WorldVertices) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var surfacesForThisEdge = [surface1WorldVertices, surface2WorldVertices];
  var position = worldPoint1.plus(worldPoint2.minus(worldPoint1).times(0.5));
  var normal = this.k3m(surfacesForThisEdge);
  var edgeRotation = Companion_getInstance_1().fromEulerDegrees$default(new Degrees(90.0)).times(Companion_getInstance_1().r2v(normal.unaryMinus(), Companion_getInstance().UP));
  var transform = new Transform(position, edgeRotation);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = listOf([surface1WorldVertices, surface2WorldVertices]);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.ipex.room.Companion.edgeDefinitions.<anonymous>' call
    var surfaceNormal = Companion_getInstance_0().a2i(item).normalize();
    var surfaceType = surfaceTypeFromNormal(Companion_instance_5, surfaceNormal);
    destination.h(surfaceType);
  }
  var adjacentSurfaceTypes = copyToArray(destination);
  var connector = Companion_instance_4.u3l(transform.inverseTransformPosition(worldPoint1), transform.inverseTransformPosition(worldPoint2), adjacentSurfaceTypes);
  return new RoomEdgeDefinition(connector, transform, adjacentSurfaceTypes);
};
protoOf(Companion_2).m3m = function (worldCornerPoint, worldVerticesOfConnectedSurfaces) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(worldVerticesOfConnectedSurfaces.length);
  var inductionVariable = 0;
  var last = worldVerticesOfConnectedSurfaces.length;
  while (inductionVariable < last) {
    var item = worldVerticesOfConnectedSurfaces[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.ipex.room.Companion.cornerDefinitions.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(item.length);
    var inductionVariable_0 = 0;
    var last_0 = item.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = item[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.ipex.room.Companion.cornerDefinitions.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item_0.minus(worldCornerPoint);
      destination_0.h(tmp$ret$0);
    }
    var tmp$ret$4 = copyToArray(destination_0);
    destination.h(tmp$ret$4);
  }
  var surfacePointsInCornerSpace = copyToArray(destination);
  var pointNormal = this.k3m(surfacePointsInCornerSpace);
  var forwardsOnPlane = new Vector(pointNormal.X, 0.0, pointNormal.Z);
  var pointRotation = Companion_getInstance_1().p2v(forwardsOnPlane.unaryMinus(), Companion_getInstance().UP);
  var transform = new Transform(worldCornerPoint, pointRotation);
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(worldVerticesOfConnectedSurfaces.length);
  var inductionVariable_1 = 0;
  var last_1 = worldVerticesOfConnectedSurfaces.length;
  while (inductionVariable_1 < last_1) {
    var item_1 = worldVerticesOfConnectedSurfaces[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.ipex.room.Companion.cornerDefinitions.<anonymous>' call
    var surfaceNormal = Companion_getInstance_0().a2i(item_1).normalize();
    var surfaceType = surfaceTypeFromNormal(Companion_instance_5, surfaceNormal);
    destination_1.h(surfaceType);
  }
  var adjacentSurfaceTypes = copyToArray(destination_1);
  var pointConnector = Companion_instance_4.w3l(Companion_getInstance().ZERO, surfacePointsInCornerSpace, adjacentSurfaceTypes);
  return new RoomCornerDefinition(pointConnector, transform, adjacentSurfaceTypes);
};
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function surfaceDefinitions(worldVertices) {
  return Companion_instance_5.j3m(worldVertices);
}
function generateMeanNormalFromPolygons(polygons) {
  return Companion_instance_5.k3m(polygons);
}
function edgeDefinitions(worldPoint1, worldPoint2, surface1WorldVertices, surface2WorldVertices) {
  return Companion_instance_5.l3m(worldPoint1, worldPoint2, surface1WorldVertices, surface2WorldVertices);
}
function cornerDefinitions(worldCornerPoint, worldVerticesOfConnectedSurfaces) {
  return Companion_instance_5.m3m(worldCornerPoint, worldVerticesOfConnectedSurfaces);
}
function RoomDefinitionsUtils() {
}
function RoomEdgeDefinition(connector, entityTransform, adjacentSurfaceTypes) {
  this.connector = connector;
  this.entityTransform = entityTransform;
  this.adjacentSurfaceTypes = adjacentSurfaceTypes;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.mandatoryComponents = [new StaticComponent(), new ConnectionRootComponent(), new SnapRootComponent(), new RoomPartComponent(Companion_instance_6.z3l_1)];
}
protoOf(RoomEdgeDefinition).t1m = function () {
  return this.connector;
};
protoOf(RoomEdgeDefinition).g3m = function () {
  return this.entityTransform;
};
protoOf(RoomEdgeDefinition).h3m = function () {
  return this.adjacentSurfaceTypes;
};
protoOf(RoomEdgeDefinition).m1w = function () {
  return this.mandatoryComponents;
};
protoOf(RoomEdgeDefinition).asComponents = function () {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.mandatoryComponents;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [this.connector];
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [new ConnectorsComponent(tmp$ret$2)];
  var this_1 = this_0.concat(tmp$ret$6);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [new LocalTransformComponent(this.entityTransform)];
  return this_1.concat(tmp$ret$11);
};
protoOf(RoomEdgeDefinition).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof RoomEdgeDefinition))
    THROW_CCE();
  if (!this.connector.equals(other.connector))
    return false;
  if (!this.entityTransform.equals(other.entityTransform))
    return false;
  if (!contentEquals(this.adjacentSurfaceTypes, other.adjacentSurfaceTypes))
    return false;
  return true;
};
protoOf(RoomEdgeDefinition).hashCode = function () {
  var result = this.connector.hashCode();
  result = imul(31, result) + this.entityTransform.hashCode() | 0;
  result = imul(31, result) + contentHashCode(this.adjacentSurfaceTypes) | 0;
  return result;
};
protoOf(RoomEdgeDefinition).tf = function () {
  return this.connector;
};
protoOf(RoomEdgeDefinition).uf = function () {
  return this.entityTransform;
};
protoOf(RoomEdgeDefinition).m1m = function () {
  return this.adjacentSurfaceTypes;
};
protoOf(RoomEdgeDefinition).n3m = function (connector, entityTransform, adjacentSurfaceTypes) {
  return new RoomEdgeDefinition(connector, entityTransform, adjacentSurfaceTypes);
};
protoOf(RoomEdgeDefinition).copy = function (connector, entityTransform, adjacentSurfaceTypes, $super) {
  connector = connector === VOID ? this.connector : connector;
  entityTransform = entityTransform === VOID ? this.entityTransform : entityTransform;
  adjacentSurfaceTypes = adjacentSurfaceTypes === VOID ? this.adjacentSurfaceTypes : adjacentSurfaceTypes;
  return this.n3m(connector, entityTransform, adjacentSurfaceTypes);
};
protoOf(RoomEdgeDefinition).toString = function () {
  return 'RoomEdgeDefinition(connector=' + this.connector.toString() + ', entityTransform=' + this.entityTransform.toString() + ', adjacentSurfaceTypes=' + toString(this.adjacentSurfaceTypes) + ')';
};
function Companion_3() {
  this.x3l_1 = 0;
  this.y3l_1 = 1;
  this.z3l_1 = 2;
  this.a3m_1 = 3;
  this.b3m_1 = 4;
  this.c3m_1 = 5;
  this.d3m_1 = 6;
  this.e3m_1 = 7;
  this.f3m_1 = 8;
}
protoOf(Companion_3).o3m = function () {
  return this.x3l_1;
};
protoOf(Companion_3).p3m = function () {
  return this.y3l_1;
};
protoOf(Companion_3).q3m = function () {
  return this.z3l_1;
};
protoOf(Companion_3).r3m = function () {
  return this.a3m_1;
};
protoOf(Companion_3).s3m = function () {
  return this.b3m_1;
};
protoOf(Companion_3).t3m = function () {
  return this.c3m_1;
};
protoOf(Companion_3).u3m = function () {
  return this.d3m_1;
};
protoOf(Companion_3).v3m = function () {
  return this.e3m_1;
};
protoOf(Companion_3).w3m = function () {
  return this.f3m_1;
};
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function get_OTHER() {
  return Companion_instance_6.x3l_1;
}
function get_CORNER() {
  return Companion_instance_6.y3l_1;
}
function get_EDGE() {
  return Companion_instance_6.z3l_1;
}
function get_WALL() {
  return Companion_instance_6.a3m_1;
}
function get_FLOOR() {
  return Companion_instance_6.b3m_1;
}
function get_CEILING() {
  return Companion_instance_6.c3m_1;
}
function get_WINDOW() {
  return Companion_instance_6.d3m_1;
}
function get_DOOR() {
  return Companion_instance_6.e3m_1;
}
function get_OBSTACLE() {
  return Companion_instance_6.f3m_1;
}
function RoomPartType() {
}
function Companion_4() {
  Companion_instance_7 = this;
  this.id = Companion_instance.u1q_1;
}
protoOf(Companion_4).n1s = function () {
  return this.id;
};
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 == null)
    new Companion_4();
  return Companion_instance_7;
}
function RoomPartComponent(type) {
  Companion_getInstance_7();
  this.type = type;
}
protoOf(RoomPartComponent).w2a = function () {
  return this.type;
};
protoOf(RoomPartComponent).p1s = function () {
  return Companion_getInstance_7().id;
};
protoOf(RoomPartComponent).x3m = function () {
  var tmp0_subject = this.type;
  return tmp0_subject === Companion_instance_6.y3l_1 ? 'corner' : tmp0_subject === Companion_instance_6.z3l_1 ? 'edge' : tmp0_subject === Companion_instance_6.a3m_1 ? 'wall' : tmp0_subject === Companion_instance_6.b3m_1 ? 'floor' : tmp0_subject === Companion_instance_6.c3m_1 ? 'ceiling' : tmp0_subject === Companion_instance_6.d3m_1 ? 'window' : tmp0_subject === Companion_instance_6.e3m_1 ? 'door' : tmp0_subject === Companion_instance_6.f3m_1 ? 'obstacle' : 'other';
};
protoOf(RoomPartComponent).y3m = function () {
  return this.type === Companion_instance_6.a3m_1 || this.type === Companion_instance_6.b3m_1 || this.type === Companion_instance_6.c3m_1;
};
protoOf(RoomPartComponent).eq = function (other) {
  if (!(other instanceof RoomPartComponent))
    return false;
  return other.typeId === this.typeId && other.type === this.type;
};
protoOf(RoomPartComponent).tf = function () {
  return this.type;
};
protoOf(RoomPartComponent).z3m = function (type) {
  return new RoomPartComponent(type);
};
protoOf(RoomPartComponent).copy = function (type, $super) {
  type = type === VOID ? this.type : type;
  return this.z3m(type);
};
protoOf(RoomPartComponent).toString = function () {
  return 'RoomPartComponent(type=' + this.type + ')';
};
protoOf(RoomPartComponent).hashCode = function () {
  return this.type;
};
protoOf(RoomPartComponent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoomPartComponent))
    return false;
  var tmp0_other_with_cast = other instanceof RoomPartComponent ? other : THROW_CCE();
  if (!(this.type === tmp0_other_with_cast.type))
    return false;
  return true;
};
function get_isRoomPart(_this__u8e3s4) {
  return _this__u8e3s4.hasComponent(Companion_getInstance_7().id);
}
function RoomSurfaceDefinition(connector, entityTransform, dragSurface, surfaceType) {
  this.connector = connector;
  this.entityTransform = entityTransform;
  this.dragSurface = dragSurface;
  this.surfaceType = surfaceType;
}
protoOf(RoomSurfaceDefinition).t1m = function () {
  return this.connector;
};
protoOf(RoomSurfaceDefinition).g3m = function () {
  return this.entityTransform;
};
protoOf(RoomSurfaceDefinition).a3n = function () {
  return this.dragSurface;
};
protoOf(RoomSurfaceDefinition).b3n = function () {
  return this.surfaceType;
};
protoOf(RoomSurfaceDefinition).m1w = function () {
  var tmp0_subject = this.surfaceType;
  var partType = tmp0_subject === Companion_instance_8.l3l_1 ? Companion_instance_6.a3m_1 : tmp0_subject === Companion_instance_8.m3l_1 ? Companion_instance_6.b3m_1 : tmp0_subject === Companion_instance_8.n3l_1 ? Companion_instance_6.c3m_1 : Companion_instance_6.x3l_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [new StaticComponent(), new ConnectionRootComponent(), new SnapRootComponent(), new RoomPartComponent(partType)];
};
protoOf(RoomSurfaceDefinition).asComponents = function () {
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  // Inline function 'kotlin.collections.plus' call
  var this_0 = this.mandatoryComponents;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [this.connector];
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$6 = [new ConnectorsComponent(tmp$ret$2)];
  var this_1 = this_0.concat(tmp$ret$6);
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [new LocalTransformComponent(this.entityTransform)];
  var this_2 = this_1.concat(tmp$ret$11);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$15 = [this.dragSurface];
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$19 = [new DragSurfacesComponent(tmp$ret$15)];
  return this_2.concat(tmp$ret$19);
};
protoOf(RoomSurfaceDefinition).tf = function () {
  return this.connector;
};
protoOf(RoomSurfaceDefinition).uf = function () {
  return this.entityTransform;
};
protoOf(RoomSurfaceDefinition).m1m = function () {
  return this.dragSurface;
};
protoOf(RoomSurfaceDefinition).n1m = function () {
  return this.surfaceType;
};
protoOf(RoomSurfaceDefinition).c3n = function (connector, entityTransform, dragSurface, surfaceType) {
  return new RoomSurfaceDefinition(connector, entityTransform, dragSurface, surfaceType);
};
protoOf(RoomSurfaceDefinition).copy = function (connector, entityTransform, dragSurface, surfaceType, $super) {
  connector = connector === VOID ? this.connector : connector;
  entityTransform = entityTransform === VOID ? this.entityTransform : entityTransform;
  dragSurface = dragSurface === VOID ? this.dragSurface : dragSurface;
  surfaceType = surfaceType === VOID ? this.surfaceType : surfaceType;
  return this.c3n(connector, entityTransform, dragSurface, surfaceType);
};
protoOf(RoomSurfaceDefinition).toString = function () {
  return 'RoomSurfaceDefinition(connector=' + this.connector.toString() + ', entityTransform=' + this.entityTransform.toString() + ', dragSurface=' + this.dragSurface.toString() + ', surfaceType=' + this.surfaceType + ')';
};
protoOf(RoomSurfaceDefinition).hashCode = function () {
  var result = this.connector.hashCode();
  result = imul(result, 31) + this.entityTransform.hashCode() | 0;
  result = imul(result, 31) + this.dragSurface.hashCode() | 0;
  result = imul(result, 31) + this.surfaceType | 0;
  return result;
};
protoOf(RoomSurfaceDefinition).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RoomSurfaceDefinition))
    return false;
  var tmp0_other_with_cast = other instanceof RoomSurfaceDefinition ? other : THROW_CCE();
  if (!this.connector.equals(tmp0_other_with_cast.connector))
    return false;
  if (!this.entityTransform.equals(tmp0_other_with_cast.entityTransform))
    return false;
  if (!this.dragSurface.equals(tmp0_other_with_cast.dragSurface))
    return false;
  if (!(this.surfaceType === tmp0_other_with_cast.surfaceType))
    return false;
  return true;
};
function Companion_5() {
  this.k3l_1 = 0;
  this.l3l_1 = 1;
  this.m3l_1 = 2;
  this.n3l_1 = 3;
}
protoOf(Companion_5).d3n = function () {
  return this.k3l_1;
};
protoOf(Companion_5).r3m = function () {
  return this.l3l_1;
};
protoOf(Companion_5).s3m = function () {
  return this.m3l_1;
};
protoOf(Companion_5).t3m = function () {
  return this.n3l_1;
};
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function get_UNKNOWN() {
  return Companion_instance_8.k3l_1;
}
function get_WALL_0() {
  return Companion_instance_8.l3l_1;
}
function get_FLOOR_0() {
  return Companion_instance_8.m3l_1;
}
function get_CEILING_0() {
  return Companion_instance_8.n3l_1;
}
function RoomSurfaceType() {
}
function pickWallsInOrder($this, wall1, wall2, cornerPoint) {
  var wall1NextVertex = nextVertexFrom($this, cornerPoint, wall1);
  var tmp;
  if (wall1NextVertex.Y === cornerPoint.Y) {
    tmp = new Pair(wall1, wall2);
  } else {
    tmp = new Pair(wall2, wall1);
  }
  return tmp;
}
function nextVertexFrom($this, cornerPoint, wall1) {
  var points = wall1.e3n_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var inductionVariable = 0;
    var last = points.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.ipex.room.WallCornerAngleOffersGenerator.nextVertexFrom.<anonymous>' call
        if (points[index].equals(cornerPoint)) {
          tmp$ret$1 = index;
          break $l$block;
        }
      }
       while (inductionVariable <= last);
    tmp$ret$1 = -1;
  }
  var index_0 = tmp$ret$1;
  var nextIndex = (index_0 + 1 | 0) % points.length | 0;
  return points[nextIndex];
}
function WallSurfaceData(points, normal) {
  this.e3n_1 = points;
  this.f3n_1 = normal;
}
protoOf(WallSurfaceData).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof WallSurfaceData))
    THROW_CCE();
  if (!contentEquals(this.e3n_1, other.e3n_1))
    return false;
  if (!this.f3n_1.equals(other.f3n_1))
    return false;
  return true;
};
protoOf(WallSurfaceData).hashCode = function () {
  var result = contentHashCode(this.e3n_1);
  result = imul(31, result) + this.f3n_1.hashCode() | 0;
  return result;
};
protoOf(WallSurfaceData).uf = function () {
  return this.f3n_1;
};
protoOf(WallSurfaceData).toString = function () {
  return 'WallSurfaceData(points=' + toString(this.e3n_1) + ', normal=' + this.f3n_1.toString() + ')';
};
function WallCornerAngleOffersGenerator$generateOffersString$lambda($points) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $points;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.ipex.room.WallCornerAngleOffersGenerator.generateOffersString.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.toString();
      destination.h(tmp$ret$0);
    }
    return 'Surface with less than 3 vertices is not a valid surface. Vertices: ' + toString(destination);
  };
}
function WallCornerAngleOffersGenerator$generateOffersString$lambda_0($walls) {
  return function () {
    return '2 walls are needed to calculate wall corner angle. Found ' + $walls.o() + ' wall(s). Note that a wall must be perfectly vertical, i.e. it has a normal with a Y-value very close to zero.';
  };
}
function WallCornerAngleOffersGenerator() {
  WallCornerAngleOffersGenerator_instance = this;
  this.s3l_1 = LoggerState_getInstance().g1v('WallCornerAngleOffersGenerator');
}
protoOf(WallCornerAngleOffersGenerator).t3l = function (surfaces, cornerPoint) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(surfaces.length);
  var inductionVariable = 0;
  var last = surfaces.length;
  while (inductionVariable < last) {
    var item = surfaces[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.ipex.room.WallCornerAngleOffersGenerator.generateOffersString.<anonymous>' call
    if (item.length < 3) {
      var tmp = WallCornerAngleOffersGenerator_getInstance().s3l_1;
      tmp.warn(WallCornerAngleOffersGenerator$generateOffersString$lambda(item));
      return null;
    }
    var normal = Companion_getInstance_0().a2i(item);
    var tmp$ret$0 = new WallSurfaceData(item, normal);
    destination.h(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var tmp0_iterator = destination.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.ipex.room.WallCornerAngleOffersGenerator.generateOffersString.<anonymous>' call
    var normal_0 = element.uf();
    if (almostEquals(normal_0.Y, 0.0, 1.0E-4)) {
      destination_0.h(element);
    }
  }
  var walls = destination_0;
  var tmp_0;
  if (walls.o() === 2) {
    var _destruct__k2r9zo = pickWallsInOrder(this, walls.q(0), walls.q(1), cornerPoint);
    var firstWall = _destruct__k2r9zo.tf();
    var secondWall = _destruct__k2r9zo.uf();
    var degreeInt = roundToInt((new Radians(firstWall.f3n_1.signedAngle(secondWall.f3n_1))).toDegree().value);
    var tmp_1;
    if (degreeInt < 0) {
      tmp_1 = 360 + degreeInt | 0;
    } else {
      tmp_1 = degreeInt;
    }
    var positiveAngle = tmp_1;
    tmp_0 = '' + positiveAngle + '-degrees';
  } else {
    this.s3l_1.warn(WallCornerAngleOffersGenerator$generateOffersString$lambda_0(walls));
    return null;
  }
  return tmp_0;
};
var WallCornerAngleOffersGenerator_instance;
function WallCornerAngleOffersGenerator_getInstance() {
  if (WallCornerAngleOffersGenerator_instance == null)
    new WallCornerAngleOffersGenerator();
  return WallCornerAngleOffersGenerator_instance;
}
//region block: post-declaration
protoOf(RoomComponent).r1s = get_serializable;
protoOf(RoomComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RoomComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RoomComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RoomComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
protoOf(RoomPartComponent).r1s = get_serializable;
protoOf(RoomPartComponent).s1s = get_doStoreInSnapshot;
defineProp(protoOf(RoomPartComponent), 'typeId', function () {
  return this.p1s();
});
defineProp(protoOf(RoomPartComponent), 'typeName', protoOf(RoomPartComponent).x3m);
defineProp(protoOf(RoomPartComponent), 'isSurface', protoOf(RoomPartComponent).y3m);
defineProp(protoOf(RoomPartComponent), 'serializable', function () {
  return this.r1s();
});
defineProp(protoOf(RoomPartComponent), 'doStoreInSnapshot', function () {
  return this.s1s();
});
defineProp(protoOf(RoomSurfaceDefinition), 'mandatoryComponents', protoOf(RoomSurfaceDefinition).m1w);
//endregion
//region block: init
Companion_instance_4 = new Companion_1();
Companion_instance_5 = new Companion_2();
Companion_instance_6 = new Companion_3();
Companion_instance_8 = new Companion_5();
//endregion
//region block: exports
defineProp(RoomComponent, 'Companion', Companion_getInstance_2);
RoomConnectorConstants.hasFloorPlacement = hasFloorPlacement;
RoomConnectorConstants.hasWallPlacement = hasWallPlacement;
RoomConnectorConstants.hasCornerPlacement = hasCornerPlacement;
RoomConnectorConstants.constantsForEdge = constantsForEdge;
RoomConnectorConstants.constantsForCorner = constantsForCorner;
defineProp(RoomConnectorConstants, 'ROOM_SURFACE_KEY', get_ROOM_SURFACE_KEY);
defineProp(RoomConnectorConstants, 'CONTINUOUS_OFFER', get_CONTINUOUS_OFFER);
defineProp(RoomConnectorConstants, 'EDGE_WALL_CEILING_OFFER', get_EDGE_WALL_CEILING_OFFER);
defineProp(RoomConnectorConstants, 'EDGE_WALL_CEILING_KEY', get_EDGE_WALL_CEILING_KEY);
defineProp(RoomConnectorConstants, 'EDGE_WALL_FLOOR_OFFER', get_EDGE_WALL_FLOOR_OFFER);
defineProp(RoomConnectorConstants, 'EDGE_WALL_FLOOR_KEY', get_EDGE_WALL_FLOOR_KEY);
defineProp(RoomConnectorConstants, 'EDGE_WALL_WALL_OFFER', get_EDGE_WALL_WALL_OFFER);
defineProp(RoomConnectorConstants, 'EDGE_WALL_WALL_KEY', get_EDGE_WALL_WALL_KEY);
defineProp(RoomConnectorConstants, 'EDGE_WALL_CEILING_OFFERS', get_EDGE_WALL_CEILING_OFFERS);
defineProp(RoomConnectorConstants, 'EDGE_WALL_FLOOR_OFFERS', get_EDGE_WALL_FLOOR_OFFERS);
defineProp(RoomConnectorConstants, 'EDGE_WALL_WALL_OFFERS', get_EDGE_WALL_WALL_OFFERS);
defineProp(RoomConnectorConstants, 'CORNER_WALL_FLOOR_OFFER', get_CORNER_WALL_FLOOR_OFFER);
defineProp(RoomConnectorConstants, 'CORNER_WALL_FLOOR_KEY', get_CORNER_WALL_FLOOR_KEY);
defineProp(RoomConnectorConstants, 'CORNER_WALL_CEILING_OFFER', get_CORNER_WALL_CEILING_OFFER);
defineProp(RoomConnectorConstants, 'CORNER_WALL_CEILING_KEY', get_CORNER_WALL_CEILING_KEY);
defineProp(RoomConnectorConstants, 'WALL_OFFER', get_WALL_OFFER);
defineProp(RoomConnectorConstants, 'FLOOR_OFFER', get_FLOOR_OFFER);
defineProp(RoomConnectorConstants, 'CEILING_OFFER', get_CEILING_OFFER);
defineProp(RoomConnectorConstants, 'TOP_SURFACE_OFFER', get_TOP_SURFACE_OFFER);
defineProp(RoomConnectorConstants, 'FLOOR_OFFERS', get_FLOOR_OFFERS);
defineProp(RoomConnectorConstants, 'WALL_OFFERS', get_WALL_OFFERS);
defineProp(RoomConnectorConstants, 'CEILING_OFFERS', get_CEILING_OFFERS);
defineProp(RoomConnectorConstants, 'Companion', Companion_getInstance_3);
RoomDefinitionsUtils.surfaceDefinitions = surfaceDefinitions;
RoomDefinitionsUtils.generateMeanNormalFromPolygons = generateMeanNormalFromPolygons;
RoomDefinitionsUtils.edgeDefinitions = edgeDefinitions;
RoomDefinitionsUtils.cornerDefinitions = cornerDefinitions;
defineProp(RoomDefinitionsUtils, 'Companion', Companion_getInstance_5);
defineProp(RoomPartType, 'OTHER', get_OTHER);
defineProp(RoomPartType, 'CORNER', get_CORNER);
defineProp(RoomPartType, 'EDGE', get_EDGE);
defineProp(RoomPartType, 'WALL', get_WALL);
defineProp(RoomPartType, 'FLOOR', get_FLOOR);
defineProp(RoomPartType, 'CEILING', get_CEILING);
defineProp(RoomPartType, 'WINDOW', get_WINDOW);
defineProp(RoomPartType, 'DOOR', get_DOOR);
defineProp(RoomPartType, 'OBSTACLE', get_OBSTACLE);
defineProp(RoomPartType, 'Companion', Companion_getInstance_6);
defineProp(RoomPartComponent, 'Companion', Companion_getInstance_7);
defineProp(RoomSurfaceType, 'UNKNOWN', get_UNKNOWN);
defineProp(RoomSurfaceType, 'WALL', get_WALL_0);
defineProp(RoomSurfaceType, 'FLOOR', get_FLOOR_0);
defineProp(RoomSurfaceType, 'CEILING', get_CEILING_0);
defineProp(RoomSurfaceType, 'Companion', Companion_getInstance_8);
export {
  RoomComponent as RoomComponent,
  RoomConnectorConstants as RoomConnectorConstants,
  RoomConnectorConstantsData as RoomConnectorConstantsData,
  RoomCornerDefinition as RoomCornerDefinition,
  RoomDefinitionsUtils as RoomDefinitionsUtils,
  RoomEdgeDefinition as RoomEdgeDefinition,
  RoomPartType as RoomPartType,
  RoomPartComponent as RoomPartComponent,
  RoomSurfaceDefinition as RoomSurfaceDefinition,
  RoomSurfaceType as RoomSurfaceType,
};
export {
  RoomComponent as RoomComponent2gkkpzoq5lilh,
  RoomPartComponent as RoomPartComponent1a7o4iq43ookc,
  get_isRoom as get_isRoom1fe449b5enr4j,
  get_isRoomPart as get_isRoomPartbpuhsyvsgmwq,
  Companion_getInstance_3 as Companion_getInstancezthp1cggtmqt,
  Companion_instance_5 as Companion_instance1t1j53owkga9v,
  Companion_getInstance_7 as Companion_getInstance2nzafxewx0x5b,
  Companion_instance_6 as Companion_instance13c20tozi5426,
  Companion_instance_8 as Companion_instancefbh6n0flhkk9,
};
//endregion

//# sourceMappingURL=ipex-room-definitions.mjs.map
